module.exports = __webpack_public_path__ + "media/images/locations/h_2-d2fcd9f6f7d850e4f8a6dc8ff35e2dbc.JPG";